// @flow

import {Tag} from 'docs/util';

import type {MarkdocFragmentRegistration} from 'docs/markdoc';

const EDGE_POSITION = ['auto', 'top', 'bottom', 'left', 'right'];

export const Edge: MarkdocFragmentRegistration = {
  tag: 'edge',
  attributes: {
    from: {
      type: String,
      required: true,
      description: 'The node ID to draw this edge from.',
    },
    to: {
      type: String,
      required: true,
      description: 'The node ID to draw this edge to.',
    },
    fromPosition: {
      type: String,
      default: 'auto',
      includes: EDGE_POSITION,
      description:
        'When manually positioning the node, the position on the node where the edge leaves.',
    },
    toPosition: {
      type: String,
      default: 'auto',
      includes: EDGE_POSITION,
      description:
        'When manually positioning the node, the position on the node where the edge enters.',
    },
    style: {
      type: String,
      required: false,
      default: 'default',
      includes: ['default', 'straight', 'step', 'smoothstep', 'dashed'],
      description: 'The style of edge to draw.',
    },
  },
  render(node, config) {
    const attributes = node.renderAttributes(this.attributes, config);
    const children = node.renderChildren(config);
    return new Tag('edge', attributes, children);
  },
};
